var React = require('react');

function CheckIconNew (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0)"},[React.createElement("path",{"fill":"#006ADB","d":"M1166.2,56.412a1.22,1.22,0,0,0-2.311.781,9.195,9.195,0,1,1-5.721-5.754,1.22,1.22,0,1,0,.795-2.306,11.634,11.634,0,1,0,7.237,7.279Z","transform":"translate(-1143.524 -48.5)","key":0}),React.createElement("path",{"fill":"#006ADB","d":"M1412.764,153.041a1.22,1.22,0,1,0-.912,2.262,6.187,6.187,0,0,1,2.256,1.656,6.619,6.619,0,0,1,.8,1.1,1.216,1.216,0,0,0,1.05.655h.031a1.224,1.224,0,0,0,1.054-.611,44.306,44.306,0,0,1,4.242-6.155,23.85,23.85,0,0,1,5.523-5,1.22,1.22,0,0,0-1.293-2.069c-3.4,2.127-6.64,5.627-9.625,10.405A8.584,8.584,0,0,0,1412.764,153.041Z","transform":"translate(-1404.89 -142.47)","key":1})]));
}

CheckIconNew.defaultProps = {"width":"23.289","height":"23.29","viewBox":"0 0 23.289 23.29"};

module.exports = CheckIconNew;

CheckIconNew.default = CheckIconNew;
